import { api } from './authService';
import axios from 'axios';

const API_BASE = 'https://2088.xn--p1ai/api';

export const collectionService = {
  getSets: (channelId) => api.get(`/collection/${channelId}/sets`).then(res => res.data),
  createSet: (channelId, data) => api.post(`/collection/${channelId}/sets`, data).then(res => res.data),
  updateSet: (setId, data) => api.put(`/collection/sets/${setId}`, data).then(res => res.data),
  deleteSet: (setId) => api.delete(`/collection/sets/${setId}`).then(res => res.data),
  getCollectionsBySetId: (setId) => api.get(`/collection/sets/${setId}/collections`).then(res => res.data),
  createCollection: (channelId, data) => api.post(`/collection/${channelId}/collections`, data).then(res => res.data),
  updateCollection: (collectionId, data) => api.put(`/collection/collections/${collectionId}`, data).then(res => res.data),
  deleteCollection: (collectionId) => api.delete(`/collection/collections/${collectionId}`).then(res => res.data),
  getSetsBySiteId: (siteId) => api.get(`/collection/site/${siteId}/sets`).then(res => res.data),
  getCollectionSetItems: (collectionSetId) => api.get(`/collection/sets/${collectionSetId}/items`).then(res => res.data),
  getCollectionsByChannelId: (channelId) => api.get(`/collection/${channelId}/collections`).then(res => res.data),

  // ✅ ПУБЛИЧНЫЕ МЕТОДЫ (без токена)
  getPublicSets: (channelId) => 
  axios.get(`${API_BASE}/public/channel/${channelId}/sets`).then(res => res.data),

getPublicSetItems: (setId) => 
  axios.get(`${API_BASE}/public/sets/${setId}/items`).then(res => res.data),

getPublicCollections: (channelId) => 
  axios.get(`${API_BASE}/public/channel/${channelId}/collections`).then(res => res.data),
};